import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

import { AccountService } from 'app/core';
import { EMAIL_PATTERN } from 'app/shared/Utils/common.utils';
import { DispositionGroup } from '../../types/dispositions.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { DispositionsService } from 'app/modules/projects/@shared/services/dispositions.service';

@Component({
  selector: 'add-dispositions-group',
  templateUrl: './add-dispositions-group.component.html',
  styleUrls: ['./add-dispositions-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class AddDispositionsGroupComponent implements OnInit {
  groupNameForm: UntypedFormGroup;
  sellersBrokerForm: UntypedFormGroup;
  buyersBrokerForm: UntypedFormGroup;
  buyerForm: UntypedFormGroup;
  public isLoading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<AddDispositionsGroupComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _dispositionService: DispositionsService,
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._dispositionService.accountId = accountData.id;
      this._projectsService.project$.subscribe((project) => {
        this._dispositionService.projectId = project.id;
      });
    });
  }

  ngOnInit(): void {
    this.sellersBrokerForm = this._formBuilder.group({
      id: [''],
      category_id: [''],
      name: [''],
      company_name: [''],
      category_name: [''],
      email: ['', [Validators.email, Validators.pattern(EMAIL_PATTERN)]],
      phone: [''],
    });

    this.buyersBrokerForm = this._formBuilder.group({
      id: [''],
      category_id: [''],
      name: [''],
      company_name: [''],
      category_name: [''],
      email: ['', [Validators.email, Validators.pattern(EMAIL_PATTERN)]],
      phone: [''],
    });

    this.buyerForm = this._formBuilder.group({
      id: [''],
      category_id: [''],
      name: [''],
      company_name: [''],
      category_name: [''],
      email: ['', [Validators.email, Validators.pattern(EMAIL_PATTERN)]],
      phone: [''],
    });

    this.groupNameForm = this._formBuilder.group({
      name: ['', Validators.required],
      description: [''],
    });

    if (this.data.group) {
      this.groupNameForm.patchValue({ name: this.data.group.name, description: this.data.group.description });
      if (this.data.group.buyer) this.buyerForm.patchValue(this.data.group.buyer);
      if (this.data.group.seller_broker) this.sellersBrokerForm.patchValue(this.data.group.seller_broker);
      if (this.data.group.buyer_broker) this.buyersBrokerForm.patchValue(this.data.group.buyer_broker);
    }
  }

  save(): void {
    let group = {
      id: '',
      name: this.groupNameForm.value.name,
      seller_broker_id: this.sellersBrokerForm.value.id,
      buyer_broker_id: this.buyersBrokerForm.value.id,
      buyer_id: this.buyerForm.value.id,
      description: this.groupNameForm.value.description,
    };
    if (this.data.group?.id) {
      group.id = this.data.group.id.toString();
      this._dispositionService
        .updateDispositionGroup(group)
        .subscribe(({ disposition_group }: { disposition_group: DispositionGroup }) =>
          this.matDialogRef.close(disposition_group),
        );
    } else {
      this._dispositionService
        .createDispositionGroup(group)
        .subscribe(({ disposition_group }: { disposition_group: DispositionGroup }) =>
          this.matDialogRef.close(disposition_group),
        );
    }
  }

  addContact(contactForm, finish = false) {
    if (!contactForm.value.id) this.saveContactAssociation(contactForm, finish);
    else {
      if (finish) this.save();
    }
  }

  discard(): void {
    this.matDialogRef.close();
  }

  saveContactAssociation(contactForm, finish): void {
    let contact = contactForm.value;

    if (contact) {
      if (!contact.id) {
        this._projectsService.createContact(contact).subscribe((newContact) => {
          contactForm.value.id = newContact.id;
          this._projectsService.createContactAssociation(newContact, this.data.project.id).subscribe(() => {
            if (finish) this.save();
          });
        });
      }
    }
  }

  // Function attached to debounce-click directive to flag the button's disable state.
  public isDebounceLoading(isLoading: boolean): boolean {
    return (this.isLoading = isLoading);
  }
}
